<template>
  <div>
   <main class="main-content">
    <section style="overflow: hidden;">
        
      <div class="row" style="height: 1200px !important; overflow:hidden !important;">
        <div class="col-md-6 pt-8" style="align-content: center;">
         
          <div  class="fvf_img"><div class="fvf_background" ></div></div>
         <div class="top-2 d-md-block d-none d-flex justify-content-center align-items-center">
           <img src="../../core_assets/img/CCD_2.png" class="img-fluid navbar-brand-img fvf_logo" alt="main_logo" style="margin-top: 40%; margin-left: 20%; height: 180px; width: 500px;">
         
         </div>
       </div>
        <div class="col-md-6 d-flex flex-column pt-6" style="align-items: center; background-color: white;">
          <div class="card card-plain">
            <div class="card-header pb-0 text-left bg-transparent text-center" style=" margin-bottom: -73%;">
              <img src="../../core_assets/img/CCD_LOGO_2.png" alt="" class="img-fluid" style="height: 30% !important;">
              <h2 class="font-weight-bolder text-primary" style="color: rgb(53, 16, 32)!important">BIENVENIDOS</h2>
              <!-- <span style="font-size: medium;"><strong>CCD</strong></span> -->
            </div>
            <div class="card-body">
              <form role="form">
                <!-- <h6 style="color: rgb(53, 16, 32)!important">Correo</h6> -->
                <div class="col-md-7 mb-3 mx-auto">
                  <input type="email" v-model="model.email" class="form-control" placeholder="Correo" aria-label="Email" aria-describedby="email-addon" v-on:keyup.enter="$refs.secondInput.focus()"  v-on:keyup.down="$refs.secondInput.focus()" ref="firstInput">
                </div>
                <!-- <h6 style="color: rgb(53, 16, 32)!important">Contraseña</h6> -->
                <div class="col-md-7 mb-3 mx-auto">
                  <input type="password" v-model="model.password" class="form-control" placeholder="Contraseña" aria-label="Password" aria-describedby="password-addon" v-on:keyup.enter="OnSubmit" v-on:keyup.up="$refs.firstInput.focus()" ref="secondInput">
                </div>
                <p class="text-center"><u><a href="recover" class="text-gradient-fvf">¿Olvidaste tu contraseña?</a></u></p> 
                <p class="text-center mb-0 " style="cursor:pointer"><a href="registro" class="text-gradient-fvf">Registrate</a></p>
                <div class="text-center col-md-7 mx-auto">
                  <button type="button" class="btn bg-gradient-fvf w-100 mt-4 mb-0" @click="OnSubmit">Acceder</button>
                </div>
              </form>
            </div>
            <div class="card-footer text-center pt-0 px-lg-2 px-1">
              <!-- <p class="mb-4 text-sm mx-auto">
                ¿No tienes cuenta?
                <a href="registro" class="text-info text-gradient font-weight-bold">Registrarse</a>
              </p> -->
              
            </div>
          </div>
        </div>

      </div>
      <br>

    </section>
  </main>
  <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
 <!-- <layout-footer></layout-footer> -->
 
</div>
</template>

<script>
import Swal from "sweetalert2";
import LayoutFooter from "./Layouts/Footer"
import { mapActions } from 'vuex'
import Cookies from "js-cookie";
export default {
  name: 'login',
  role: Cookies.get("id_role"),
  components:{
    LayoutFooter
  },
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions(["login"]),

    OnSubmit() {
      if (this.model.email == "" || this.model.password == "") {
        Swal.fire({
          title: 'Atención',
          text: 'Complete todos los campos para continuar',
          icon: 'warning',
          customClass: {
            confirmButtonColor: "#B49B57",
            confirmButton: "btn-info"
          }
        })
      } else {
        Swal.showLoading()
        this.login(this.model)
          .then((response => {
            
            if (response.code == 200) {
              this.$router.push('/overview')
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "success",
                title: "¡Bienvenido!",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              });
            }
            else if (response.code == 403) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Este usuario no puede acceder al panel administrativo",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }
            else if (response.code == 402) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Usuario no registrado, intente nuevamente",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            } else {
              Swal.fire({
                title: "¡Ocurrió un error!",
                text: "Usuario no registrado, intente nuevamente",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }
          }))
          .catch((error => {
            console.log(error)
            if (error.code == 402) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Usuario no registrado, intente nuevamente",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }
            else if (error.code == 403) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Este usuario no puede acceder al panel administrativo",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }
            else if (error.code == 404) {
              Swal.fire({
                title: "Usuario no encontrado",
                text: "No se encuentra un usuario activo con estos datos",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }
            else {
              Swal.fire({
                title: "¡Ocurrió un error!",
                text: "Usuario no registrado, intente nuevamente",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info"
                }
              })
            }

          }))
      }
    }
  }
}
</script>
<style>
.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  } */
}

body{
  font-family: 'Jost' !important;
  /* text-transform: uppercase !important; */
}

.card .card-body {
  font-family: 'Jost' !important;
}

.page-header .container{
  margin: 0px;
  padding: 0px;
  z-index: 0;
}

.fvf_background{
  /* background-image: url("../../../public/img/login-fondo.jpg");  */
  background-color:  rgb(53, 16, 32, .8) !important;
  backdrop-filter: blur(2px);
   /* Add the blur effect */
   height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
 
}
.fvf_img{
  background-image: url("../../../public/img/login-fondo.jpg"); 
  /* Center and scale the image nicely */
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
}

.fvf_logo{
  filter: blur(0px) !important;
  z-index: 5;
  position: absolute;
  top: 0%;
  left: -4%;
}

.form-control {   
    border-radius: 30px !important;
}

.btn{
  border-radius: 30px !important;
  box-shadow: 0 4px 7px -1px #B49B57, 0 2px 4px -1px #B49B57 !important;
}

.bg-gradient-fvf{
  background-color:rgb(53, 16, 32) !important;
  color: white !important;
}

.bg-gradient-fvf-switch{
  background-color:white !important;
  color: rgb(53, 16, 32) !important;
  box-shadow: none !important;
}

.text-gradient-fvf{
  color:rgb(53, 16, 32);
}

.text-fvf{
  color:#B49B57;
}

.multiselect__tags {
  border-radius: 30px !important;
}

.multiselect__content-wrapper {
  border-radius: 30px !important;
  position: absolute;
  z-index: 1;
}

/* .swal2-container.swal2-center > .swal2-popup {
  background-color:#541A32 !important;
  color: #B49B57 !important;
   
} */

.swal2-container.swal2-center > .swal2-popup {
  z-index: 10000 !important;
}

.swal2-container {
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm{
  background-color: #541A32 !important;
  color:  white !important;
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-cancel{
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.btn:hover:not(.btn-icon-only) {
    box-shadow: 0 3px 5px -1px rgb(53, 16, 32), 0 2px 3px -1px rgb(53, 16, 32) !important;
    transform: scale(1.02) !important;
    background-color: #B49B57 !important;
    color: rgb(53, 16, 32) !important;
}

.btn-info:hover {
    color: rgb(53, 16, 32) !important;
    background-color: white !important;
    border-color: rgb(53, 16, 32) !important;
}

.btn-info {
    border-color: #B49B57 !important;
}

.btn-info {
    --bs-btn-border-color: #B49B57 !important;
    --bs-btn-hover-border-color: #B49B57 !important;
    --bs-btn-active-border-color: #B49B57 !important;
    --bs-btn-disabled-border-color: #B49B57 !important;
}

.swal2-styled.swal2-confirm:focus {
    box-shadow: 0 0 0 3px #B49B57 !important;
}

.btn.focus, .btn:focus {
    box-shadow: 0 0 0 0.2rem #B49B57 !important;
}

.page-item.active .page-link {
    background-color: rgb(53, 16, 32) !important;
    border-color: #B49B57 !important;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  background-color: #B49B57  !important;
  color: white !important;
}
.multiselect__option--highlight {
  background: #B49B57!important;
  background-color: #B49B57 !important; /* Cambiar el color a vinotinto */
}

.multiselect__option--highlight:after{
  background: #B49B57 !important;/* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight{
  background: rgb(53, 16, 32) !important;/* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight:after{
  background: rgb(53, 16, 32) !important;/* Cambiar el color a vinotinto */
}

.rif-number {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.rif-prefix {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  
}

.rif-number .form-control {   
    border-top-right-radius: 30px !important;
    border-bottom-right-radius: 30px !important;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    height: 40px !important;
    margin-top: 1px !important;
}

.rif-prefix .multiselect__tags {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.rif-prefix .multiselect__content-wrapper {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

</style>